



































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import FieldArea from "@/models/coding/fieldArea/fieldAreaModel";
@Component
export default class FieldAreaAdd extends GenericAdd<FieldArea> {
  constructor() {
    super();
    this.controller = "FieldAreas";
    this.model = new FieldArea();
  }
  saveAll(){
      this.model.areaId = this.$route.params.areaId as any;
      return this.validate();
  }
  public convertirAMinuscula(event: any) {
    this.model.key = event.target.value.toLowerCase();
  }
}
